var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileSettingIconPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    stroke: "#FFF",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M21.968 0c1.325 0 2.493.869 2.873 2.138L25.4 4H31c1.657 0 3 1.343 3 3v18c0 1.657-1.343 3-3 3H3c-1.657 0-3-1.343-3-3V7c0-1.657 1.343-3 3-3h5.6l.559-1.862C9.539.869 10.707 0 12.032 0h9.936z",
    transform: "translate(-170 -152) translate(0 101) translate(143 24) translate(27 27) translate(1 4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17 7c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm0 3c-.552 0-1 .448-1 1v3h-3c-.552 0-1 .448-1 1s.448 1 1 1h3v3c0 .552.448 1 1 1s1-.448 1-1v-3h3c.552 0 1-.448 1-1s-.448-1-1-1l-3-.001V11c0-.552-.448-1-1-1z",
    transform: "translate(-170 -152) translate(0 101) translate(143 24) translate(27 27) translate(1 4)"
  })));
}
export default SvgProfileSettingIconPhoto;